
import React, { useEffect } from "react";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import { BreadcrumbItem } from "reactstrap";
import { Navbar, NavbarProvider } from "@repoflow/components/navbar";
import {
  Sidebar,
  SidebarProvider
} from "@repoflow/components/sidebar-menu";
import { useAccount } from "@repoflow/components/account";
import { basename } from "env";
import * as AuthRoute from "./auth";
import * as DashboardRoute from "./dashboard";
import * as DomainsRoute from "./domains";
import * as KeysRoute from "./keys";
import * as AccountRoute from "./account";

// The root still lands on Domains: that is the section this app is worked in.
//
// /dashboard is where the sign-in flow and every existing bookmark already
// point, and as of 2026-08-11 it renders the organization's statistics rather
// than redirecting here. It was a redirect before that, and before THAT it was
// an empty page — nothing routed it, so it fell through to this same redirect,
// which replaced the URL with itself and rendered null. bucketws made the same
// move for the same reason. See docs/auth-statistics.md.
const RootRoute = () => <Redirect to={`/domain`} />;

function Routes() {
  const account = useAccount();

  useEffect(() => {
    if (!account && !window.location.pathname.startsWith(`${basename}/auth`)) {
      window.location.href = `${basename}/auth/home`;
    }
  }, [account]);

  return (
    <Switch>
      <Route path={`/auth`} component={AuthRoute.Content} />
      {/* No `component` prop here: in react-router v5 children take
          precedence over it, so one was always dead code. */}
      <Route path={`/`}>
        <NavbarProvider>
          <SidebarProvider>
            <Navbar title={"Repoflow Auth"} menu={[]} />

            <Sidebar
              menu={[
                {
                  // The same icon bucketws' dashboard entry uses. Font Awesome
                  // 4 names it `tachometer`; `dashboard` is an alias that this
                  // build's stylesheet does not carry.
                  icon: "tachometer",
                  label: "Dashboard",
                  to: `/dashboard`,
                },
                {
                  icon: "globe",
                  label: "Domains",
                  to: `/domain`,
                },
                // The signed-in account's own keys. The same rows are reachable
                // under /domain/:domain/organization/:orgId/key, which is the
                // administrator's view of somebody else's organization; this is
                // the one every other app in the platform has.
                {
                  icon: "key",
                  label: "API Keys",
                  to: `/key`,
                },
              ]}
            >
              <ol className="breadcrumb m-0 small">
                <BreadcrumbItem>
                  <Link to={`/`}>
                    <i className="fa fa-home"></i>
                  </Link>
                </BreadcrumbItem>
                <Switch>
                  <Route
                    path={`/account`}
                    component={AccountRoute.Indice}
                  />
                  <Route
                    path={`/dashboard`}
                    component={DashboardRoute.Indice}
                  />
                  <Route
                    path={`/domain`}
                    component={DomainsRoute.Indice}
                  />
                  <Route
                    path={`/key`}
                    component={KeysRoute.Indice}
                  />

                </Switch>
              </ol>

              <Switch>

                <Route path={`/account`} component={AccountRoute.Content} />
                <Route path={`/dashboard`} component={DashboardRoute.Content} />
                <Route path={`/domain`} component={DomainsRoute.Content} />
                <Route path={`/key`} component={KeysRoute.Content} />
                <Route path={`/`} component={RootRoute} />
              </Switch>
            </Sidebar>
          </SidebarProvider>
        </NavbarProvider>
      </Route>
    </Switch>
  );
}

export default Routes;
